import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page98() {
  useEffect(() => {
    document.title = "Маяк — Страница 97"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page96" />
        <ForwardLink href="/page98" />
      </div>

      <p style={{ textAlign: "right" }}>97.</p>
      <p>
        Когда он касается света, слышен глубокий, басовитый, потрескивающий<br/>
        звук...
      </p>
      <p>СВЕТ становится все ярче...</p>
      <p>Его рука горит, но он продолжает тянуться...</p>
      <p>Потрескивающий звук становится громче и более потусторонним...</p>
      <p>МОЛОДОГО начинает трясти от безумия...</p>
      <p>Его лицо искажается...</p>
      <p>СВЕТ СТАНОВИТСЯ ВСЕ ЯРЧЕ...</p>
      <p>МОЛОДОЙ КРИЧИТ...</p>
      <p>ЯРЧЕ...</p>
      <p>НЕВЕРОЯТНО ЯРКИМ...</p>
      <p>
        МОЛОДОЙ начинает дрожать, плакать, он в ужасе<br/>
        от увиденного...
      </p>
      <p>Он не может понять это...</p>
      <p>У него пена изо рта....</p>
      <p>Он балансирует на волоске...</p>
      <p>Теряет равновесие... падает...</p>
      <p>Он падает назад из кадра...</p>
      <p>ИЗ ФОНАРНОГО ОТДЕЛЕНИЯ...</p>
      <p>ПАДЕНИЕ.</p>
      <p>В МАШИННОЕ ОТДЕЛЕНИЕ...</p>
      <p>БЭНГ.</p>
      <p>И ВНИЗ ПО ЛЕСТНИЦЕ...</p>
      <p>
        ...Весь путь вниз по длинной винтовой лестнице, кувыркаясь,<br/>
        кувыркаясь, кряхтя, извиваясь, ломая кости и с грохотом скатываясь<br/>
        вниз по четырем этажам лестницы, пока не приземляется с глухим...<br/>
      </p>
      <p>БУХ.</p>
      <p>Он дышит?</p>
      <p>ЭКРАН ИСЧЕЗАЕТ В БЕЛОЕ.</p>
      <p style={{ textAlign: "right" }}>97.</p>

      <Navigation />
      
      <div className="NavigationLink-wrapper">
        <BackLink href="/page96" />
        <ForwardLink href="/page98" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1710719376/the-lighthouse-script/s8zsahwobosgrm5r8pag.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page98;
